import React, { useContext, useRef } from "react";
import styled from "@emotion/styled";
import DataGrid from "./DataGrid";
import BasicInformation from "./BasicInformation";
import Menu from "./Menu";
import mq from "../utils/mediaQueries";
import { breakpoints } from "../hooks/useBreakpoint";
import useWindowSize from "../hooks/useWindowSize";
import Inventory from "./Inventory";
import AppContext from "../AppContext";
import { useReactToPrint } from "react-to-print";
import ComponentToPrint from "../print";
import { isSafari } from "react-device-detect";

const Wrapper = styled.div`
  box-sizing: border-box;
  max-width: 100%;
  min-height: 730px;
  grid-area: mainScreen;
  display: flex;
  flex-direction: column;

  ${mq("lg")} {
    flex-direction: row;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.black};
  color: ${({ theme }) => theme.header};
  padding: 1rem;
  box-sizing: border-box;

  ${mq("sm")} {
    border: 0.25rem solid ${({ theme }) => theme.header};
    box-shadow: 0.125rem 0.125rem ${({ theme }) => theme.body},
      inset 0.125rem 0.125rem ${({ theme }) => theme.body};
    padding: 2rem;
  }
`;

const MainScreen = () => {
  const { width } = useWindowSize();
  const { character, reroll } = useContext(AppContext);

  const printRef = useRef();
  const print = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <Wrapper>
      <InnerWrapper>
        <OuterContainer>
          <Menu
            reroll={reroll}
            print={print}
            showContact={width >= breakpoints.sm}
            showPrint={width >= breakpoints.md && !isSafari}
          />
          <BasicInformation character={character} />
          <DataGrid character={character} />
          <Inventory character={character} />
          {width < breakpoints.md && !isSafari && (
            <Menu showRender={false} showContact={false} print={print} />
          )}
          {width < breakpoints.sm && !isSafari && <br />}
          {width < breakpoints.sm && (
            <Menu showRender={false} showPrint={false} />
          )}
        </OuterContainer>
      </InnerWrapper>
      <div style={{ display: "none" }}>
        <ComponentToPrint character={character} ref={printRef} />
      </div>
    </Wrapper>
  );
};

export default MainScreen;
